import axios from 'axios'
import _ from 'underscore'

const API = process.env.BASE_URL
let streetsPromise = null
let streets = []

export default {
  getStreets: function () {
    if (streetsPromise == null) {
      streetsPromise = axios.get(`${API}/streets`).then(response => {
        streets.push(..._.pluck(response.data.streets, 'name'))
      })
    }
    return streets
  }
}
